import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Sgkd020dSrnInfo } from '../models/sgkd020d-srn-info';

@Injectable({
  providedIn: 'root'
})
/**
 * 検索ボタン押下し、取得した情報を保持するクラス
 */
export class UsedSgkd020dKouzaFubiInfoService {

  private srnInfoSubject =
  new BehaviorSubject<Sgkd020dSrnInfo>({
    kohuricreMskmaceptInformationlist: []
  });

  constructor() { }


  public sgkd020dSrnInfo$: Observable<Sgkd020dSrnInfo> =
    this.srnInfoSubject.asObservable();

  setSgkd020dSrnInfo(info: Sgkd020dSrnInfo): void {
    this.srnInfoSubject.next(info);
  }

  getSgkd020dSrnInfo(): Sgkd020dSrnInfo {
    return this.srnInfoSubject.getValue();
  }

  clearSgkd020dSrnInfo(): void {
    this.srnInfoSubject.next({
      kohuricreMskmaceptInformationlist: []
    });
  }
}
